import type {TabKey} from '@Components/tabs';
import {StockPanelTabs} from '@Panels/stock-panel/stock-panel.types';

export interface StockMediaTabsProps {
  tabs: StockPanelTabs[];
  selectedTab: StockPanelTabs;
  tabId: string;
  isMobile: boolean;

  onTabClick(tabKey: TabKey): void;
}

export interface StockTabMetadata {
  icon: string;
  i18nKey: string;
}

/** Marker class the shared Tabs component stamps on the active tab item. */
export const ACTIVE_TAB_SELECTOR = '.js-tab-active';

export const STOCK_TAB_METADATA: Record<StockPanelTabs, StockTabMetadata> = {
  [StockPanelTabs.ALL]: {icon: 'icon-media', i18nKey: 'pmwjs_all'},
  [StockPanelTabs.PHOTOS]: {icon: 'icon-image', i18nKey: 'pmwjs_photos_2'},
  [StockPanelTabs.VIDEOS]: {icon: 'icon-video', i18nKey: 'pmwjs_videos_2'},
  [StockPanelTabs.SHAPES]: {icon: 'icon-elements', i18nKey: 'pmwjs_shapes'},
  [StockPanelTabs.STICKERS]: {icon: 'icon-sticker', i18nKey: 'pmwjs_stickers'},
  [StockPanelTabs.ICONS]: {icon: 'icon-icons', i18nKey: 'pmwjs_icons'},
  [StockPanelTabs.AUDIOS]: {icon: 'icon-audio', i18nKey: 'pmwjs_audios_2'},
  [StockPanelTabs.TEXT_TO_IMAGE]: {icon: 'icon-ai-image', i18nKey: 'pmwjs_ai_images'},
};
